import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsFeaturedAttributesStyles {
    attributeTypeLabelText?: TypographyPresentationProps;
    list?: TypographyPresentationProps;
}

export const productDetailsFeaturedAttributesStyles: ProductDetailsFeaturedAttributesStyles = {
    attributeTypeLabelText: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.base};
            font-weight: ${x => x.theme.design.typography.weight.bold};
            padding: ${pxToRem(10, 5, 15, 0)};
        `,
    },
    list: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.base};
        `,
    },
};

const styles = productDetailsFeaturedAttributesStyles;

const ProductDetailsFeaturedAttributes: React.FC<Props> = ({ product: { brand, attributeTypes } }) => {
    if (!brand && (!attributeTypes || !attributeTypes.length)) {
        return null;
    }
    return (
        <Typography as="ul" {...styles.list}>
            {brand && (
                <Typography as="li">
                    <Typography {...styles.attributeTypeLabelText}>{translate("Brand")}:</Typography>
                    <Typography>{brand.name}</Typography>
                </Typography>
            )}
            {attributeTypes?.slice(0, 5).map(attributeType => {
                return (
                    attributeType.attributeValues?.length && (
                        <Typography as="li" key={attributeType.id.toString()} data-attributetypeid={attributeType.id}>
                            <Typography {...styles.attributeTypeLabelText}>
                                {attributeType.label || attributeType.name}:
                            </Typography>
                            <Typography>
                                {(attributeType.attributeValues ?? [])
                                    .map(attributeValue => attributeValue.valueDisplay)
                                    .join(", ")}
                            </Typography>
                        </Typography>
                    )
                );
            })}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsFeaturedAttributes),
    definition: {
        displayName: "Featured Attributes",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
